<template>
  <v-dialog
    v-model="splitedTreeDialog"
    :disabled="disabled"
    style="width:100%"
    width="1000"
  >
    <v-btn
      slot="activator"
      small
      :disabled="disabled"
      block
    >
      Просмотр дерева разбивки
    </v-btn>
    <v-card>
      <v-card-title>
        <h4 class="subheading">
          Дерево разбивки поставки
        </h4>
      </v-card-title>
      <v-card-text id="splittad-tree-card">
        <TreeChart :json="shippingTree" />
      </v-card-text>
      <v-card-actions>
        <v-btn
          small
          @click="()=>{splitedTreeDialog=false; $emit('input',splitedTreeDialog);}"
        >
          Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ItemImg from "../../../../assets/local_shipping_black_icon.png";
import TreeChart from "vue-tree-chart";
import { getSplittedTree } from "../../../../backend/shippingsApi.js";

export default {
  components: {
    TreeChart,
  },
  props: ["id", "value", "disabled", "shippingNumber"],
  data() {
    return {
      splitedTreeDialog: this.value,
      treeData: {},
    };
  },
  computed: {
    shippingTree() {
      return this.treeData;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await getSplittedTree(this.id);
      const mappedData = {};
      mappedData.name = res.data.Name;
      mappedData.image_url = ItemImg;
      mappedData.children = this.mapDataChildren(res.data.Children);

      this.treeData = mappedData;
    },
    mapDataChildren(data) {
      const children = [];
      data.forEach(shipping => {
        var itemChild = {
          name: shipping.Name,
          image_url: ItemImg,
        };

        itemChild.children = this.mapDataChildren(shipping.Children);

        children.push(itemChild);
      });

      return children;
    },
  },
};
</script>

<style>
#splittad-tree-card.v-card__text {
  -webkit-text-align: -webkit-center;
  -moz-text-align: -webkit-center;
  -ms-text-align: -webkit-center;
  -khtml-text-align: -webkit-center;
  -o-text-align: -webkit-center;
  text-align: -webkit-center;
}

#splittad-tree-card .node .person {
  width: auto !important;
}
</style>
